import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Router } from "./routes/Router";
import { Toaster } from "./components/ui";
import { AppSnackbar } from "./components";

function App() {
  return (
    <BrowserRouter>
      <Router />
      <AppSnackbar />
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
